import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function PaymentsIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33334 5.99999H7.66668C7.11439 5.99999 6.66668 6.44771 6.66668 6.99999C6.66668 7.55228 7.11439 7.99999 7.66668 7.99999H8.33334C8.88563 7.99999 9.33334 8.44771 9.33334 8.99999C9.33334 9.55228 8.88563 9.99999 8.33334 9.99999H6.66668M8.00001 5.33333V5.99999M8.00001 9.99999V10.6667M12 7.99999H12.0067M4.00001 7.99999H4.00668M1.33334 5.46666L1.33334 10.5333C1.33334 11.2801 1.33334 11.6534 1.47867 11.9386C1.6065 12.1895 1.81047 12.3935 2.06136 12.5213C2.34657 12.6667 2.71994 12.6667 3.46668 12.6667L12.5333 12.6667C13.2801 12.6667 13.6534 12.6667 13.9387 12.5213C14.1895 12.3935 14.3935 12.1895 14.5214 11.9386C14.6667 11.6534 14.6667 11.2801 14.6667 10.5333V5.46666C14.6667 4.71993 14.6667 4.34656 14.5214 4.06134C14.3935 3.81046 14.1895 3.60649 13.9387 3.47865C13.6534 3.33333 13.2801 3.33333 12.5333 3.33333L3.46668 3.33333C2.71994 3.33333 2.34657 3.33333 2.06136 3.47865C1.81047 3.60648 1.6065 3.81046 1.47867 4.06134C1.33334 4.34656 1.33334 4.71992 1.33334 5.46666ZM12.3333 7.99999C12.3333 8.18409 12.1841 8.33333 12 8.33333C11.8159 8.33333 11.6667 8.18409 11.6667 7.99999C11.6667 7.8159 11.8159 7.66666 12 7.66666C12.1841 7.66666 12.3333 7.8159 12.3333 7.99999ZM4.33334 7.99999C4.33334 8.18409 4.18411 8.33333 4.00001 8.33333C3.81592 8.33333 3.66668 8.18409 3.66668 7.99999C3.66668 7.8159 3.81592 7.66666 4.00001 7.66666C4.18411 7.66666 4.33334 7.8159 4.33334 7.99999Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
